import { useSelector } from 'react-redux'
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import ModifyIPForm from '../components/ModifyIPForm';


const SwallowModifyPage = (uuid) => {
    const customization = useSelector((state) => state.customization);

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                    {customization.login && (<ModifyIPForm uuid={uuid}/>)}
            </Grid>
        </Grid>
    );
};

export default SwallowModifyPage;